"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("src/utilities/styled/color"));
var map = {
    primary: 0,
    secondary: 1,
    nav: 2,
};
exports.default = (function (type, _a) {
    var _b = _a === void 0 ? {} : _a, hovered = _b.hovered, active = _b.active;
    return function (_a) {
        var theme = _a.theme, background = _a.background, brand = _a.brand;
        var index = brand ? 3 : map[type];
        if (hovered) {
            return theme.palette.buttonBgHover[index];
        }
        if (active) {
            return theme.palette.buttonBgActive[index];
        }
        return background ? (0, color_1.default)({ theme: theme, color: background }) : theme.palette.buttonBg[index];
    };
});
